import ErrorMessage from '@components/elements/error-message/error-message';
import { isSome } from '@crocodille/util';

import styles from './input-envelope.module.scss';

export interface InputEnvelopeProps {
  readonly error?: string | null;
}

function InputEnvelope({
  error,
  children,
}: React.PropsWithChildren<InputEnvelopeProps>): React.JSX.Element {
  return (
    <div className={styles.container}>
      {children}
      {isSome(error) ? <ErrorMessage>{error}</ErrorMessage> : null}
    </div>
  );
}

export default InputEnvelope;
